export default function R_HOME() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_HOME Component</h1>
      <p>This is the R_HOME tutorial section.</p>
    </div>
  );
}
